import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateDiscountDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createDiscountTickets } = EventsApiService();

export const useCreateDiscountTickets = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CreateDiscountDTO) => {
            return createDiscountTickets(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Discount has been created successfully!!");
            },
        },
    );
};
